import { RouteObject } from 'react-router-dom'
import GatewayCallback from './index'
import WalletLayout from 'layout/wallet/walletLayout'
import Verify from './verify'
import FundRepayment from './fundRepayment'
import ErrorBug from 'components/errors/bugs'

export const gatewayRoutes: RouteObject[] = [
    {
        path: '/',
        element: <WalletLayout />,
        errorElement: <ErrorBug />,
        children: [
            {
                index: true,
                path: 'gateway-callback',
                element: <Verify />,
            },
            {
                index: false,
                path: 'group-all-payment',
                element: <GatewayCallback />,
            },
            {
                index: false,
                path: 'pay-to-box',
                element: <FundRepayment />,
            },
        ],
    },
]
